import { Preferences } from "@capacitor/preferences";
import { User, AppSettings } from "@core/types";
import { activeModule } from "../../providers/active-module";
export class LocalStorageOperations {
  static activeModuleUserKey = `${activeModule}-user`;
  static saveUserInfo(user: User) {
    // replace any
    Preferences.set({ key: this.activeModuleUserKey, value: JSON.stringify(user) });
  }

  static async updateUserInfo(user: Partial<User>) {
    const userInfo = await this.getUserData() || {};
    Preferences.set({ key: this.activeModuleUserKey, value: JSON.stringify({ ...userInfo, ...user }) });
  }

  static async getUserData(): Promise<User | undefined> {
    const { value } = await Preferences.get({ key: this.activeModuleUserKey });
    if (value) {
      return JSON.parse(value);
    }
  }

  static removeUserInfo(): void {
    Preferences.remove({ key: this.activeModuleUserKey });
  }

  static setAppSettings(settings: AppSettings): void {
    Preferences.set({ key: "appSettings", value: JSON.stringify(settings) });
  }

  static async getAppSettings(): Promise<AppSettings | undefined> {
    const { value } = await Preferences.get({ key: "appSettings" });
    if (value) {
      return JSON.parse(value);
    }
  }
}
